<ejs-dialog #saveAsTemplateDialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false"
            (close)="onCancel()">
  <ng-template #header>
    {{'i18n.domain.export-configuration.configurations.forms.file.field-configuration.form-fields.template-name-title' | translate}}
  </ng-template>

  <ng-template #content>
    <form [formGroup]="form">
      <div class="form-row row">
        <div class="form-group col">
          <label for="templateName"
             class="control-label required">{{'i18n.shared.template-name'| translate}}</label>
          <input id="templateName"
             type="text"
             class="form-control"
             formControlName="templateName"/>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-primary e-flat" (click)="onOk()" [disabled]="!form?.valid">{{'i18n.shared.ok' | translate}}</button>
      <button class="e-control e-btn e-lib e-flat" (click)="onCancel()">{{'i18n.shared.cancel' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
